import React from "react";
import { useNavigate } from "react-router-dom";
import { getAmountInCurrencyFormat } from "../../utils/number";

export default function StatsCard({ title, value, percent, link }) {
  const navigate = useNavigate();
  return (
    <div
      className="col-12 col-md-6 mt-3"
      onClick={() => {
        if (!link) return;
        navigate(`/postdatework?filter=${link}`);
      }}
    >
      <div className="card cardDashboard pt-2 py-3">
        <div className="fs-4 text-center">{title}</div>

        <div className="percentCardMain">
          <div className="fs-1">
            {title?.toLowerCase() === "total customers"
              ? value
              : getAmountInCurrencyFormat(value)}
          </div>
          {/* <div className="text-center percentCard">{percent}%</div> */}
        </div>
      </div>
    </div>
  );
}
